<template>
  <div class="link-interface">
    <h3>Downloads and Links</h3>
    <p>Now that you've created your image, you can take it with you!</p>
    <ul>
      <li><a :href="contentStateUrl">Permalink for this page</a></li>
      <li>
        <a v-if="gifData" :href="gifURL" :download="stringToSlug(label)">
          Download Flicker GIF
          <span class="deemphisized">({{ filesize(gifData.size) }})</span>
        </a>
        <span v-else>...generating GIF </span>
      </li>
    </ul>
  </div>
</template>

<script>
import filesize from "filesize";

export default {
  name: "AccessBox",
  data: function () {
    return { filesize: filesize };
  },
  methods: {
    stringToSlug: function (str) {
      str = str.replace(/^\s+|\s+$/g, ""); // trim
      str = str.toLowerCase();

      // remove accents, swap ñ for n, etc
      var from = "åàáãäâèéëêìíïîòóöôùúüûñç·/_,:;";
      var to = "aaaaaaeeeeiiiioooouuuunc------";

      for (var i = 0, l = from.length; i < l; i++) {
        str = str.replace(new RegExp(from.charAt(i), "g"), to.charAt(i));
      }

      str = str
        .replace(/[^a-z0-9 -]/g, "") // remove invalid chars
        .replace(/\s+/g, "-") // collapse whitespace and replace by -
        .replace(/-+/g, "-") // collapse dashes
        .replace(/^-+/, "") // trim - from start of text
        .replace(/-+$/, ""); // trim - from end of text

      return str;
    },
  },
  props: {
    label: {
      type: String,
    },
    gifData: {
      type: Blob,
    },
    contentStateUrl: {
      type: String,
    },
  },
  computed: {
    gifURL: function () {
      return URL.createObjectURL(this.gifData);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped lang="scss">
.link-interface {
  grid-column: 2 / 3;
  grid-row: 3;
  @include interface-box;
}

.deemphisized {
  font-size: 90%;
  opacity: 0.75;
}
</style>
